import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import filterNumbers from 'notebook/tables/excess/util/filterNumbers';
import product from 'notebook/tables/excess/util/product';

export default {
  name: 'PRODUCT',
  shortDescription: 'Result of multiplying a series of numbers together.',
  category: FunctionCategory.MATH,
  description: 'Returns the result of multiplying a series of numbers together.',
  params: [
    {
      name: 'value',
      type: ArgType.any,
      description: 'The first number or range to calculate for the product.',
    },
  ],
  repeatableLastParamType: ArgType.any,
  repeatableLastParamDescription: 'More numbers or ranges to calculate for the product.',

  eval: (...values): number => {
    const numberValues = filterNumbers(values);
    return product(numberValues);
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
